<template>
	<AppDialog max-width="1100" width="90vw" disableMaxWidth :closeTop="'-30'" :closeRight="'-10'" dialogName="WorkflowsSelectionDialog">
		<Col class="dialog-content rounded pt-6 px-7 pb-5 flex-justify-space-between">
			<Col class="flows-container">
				<FlowsView :showHeader="false" :filterBy="filterBy" :idsToPrepend="selectedWorkflowsIds">
					<template #card="{ flowData }">
						<AppTooltip
							:disabled="!isDisabled(flowData)"
							:text="'This feature is associated with another button dropdown, which is the maximum allowed'"
						>
							<ModuleCard
								:flowData="flowData"
								v-bind="moduleCardProps"
								class="width-100 router-link"
								@click.native="clickedModuleCard(flowData.id)"
								:class="{ selected: isSelected(flowData.id), disabled: isDisabled(flowData) }"
							/>
						</AppTooltip>
					</template>
					<template #empty-state>
						<Col class="width-100 height-100 flex-centerize pl-8 pt-12 mt-12">
							<h2 class="reg">&nbsp;No add-ons found</h2>
						</Col>
					</template>
				</FlowsView>
			</Col>
			<Row class="flex-centerize pt-5">
				<AnemicButton tile @click="save" class="save-button pa-0"> Save </AnemicButton>
			</Row>
		</Col>
	</AppDialog>
</template>
<script>
import ModuleCard from '@/components/Modules/ModuleCard.vue';
import FlowsView from '@/views/AppContentPages/FlowsView.vue';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'WorkflowsSelectionDialog',
	components: {
		AppDialog,
		FlowsView,
		ModuleCard,
	},
	props: {
		selectedWorkflowsIds: { type: Array },
		dialogPromiseHandlers: { type: Object },
		currentButtonDropdownId: { type: Number },
		filterBy: { type: Object, default: () => ({}) },
	},
	computed: {
		moduleCardProps() {
			return {
				navigateOnClick: false,
				showShareButton: false,
				showProjectChip: false,
				showActivityStatus: false,
				showFeatureVisibility: false,
				currentButtonDropdownId: this.currentButtonDropdownId,
			};
		},
	},
	methods: {
		clickedModuleCard(flowId) {
			if (this.localSelectedWorkflowsIds.includes(flowId)) {
				this.removeWorkflow(flowId);
			} else {
				this.addWorkflow(flowId);
			}
		},
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		removeWorkflow(workflowId) {
			this.localSelectedWorkflowsIds = this.localSelectedWorkflowsIds.filter((id) => id !== workflowId);
		},
		addWorkflow(workflowId) {
			this.localSelectedWorkflowsIds = [...this.localSelectedWorkflowsIds, workflowId];
		},
		async save() {
			this.dialogPromiseHandlers.resolve({ workflows: this.localSelectedWorkflowsIds });
			AppDialogManagerService.closeCurrentDialog();
		},
		isSelected(flowId) {
			return this.localSelectedWorkflowsIds.find((id) => id === flowId);
		},
		isDisabled(flow) {
			return flow.button_dropdown && flow.button_dropdown !== this.moduleCardProps.currentButtonDropdownId;
		},
	},
	created() {
		this.localSelectedWorkflowsIds = this.selectedWorkflowsIds;
	},
	data() {
		return {
			localSelectedWorkflowsIds: [],
		};
	},
};
</script>
<style scoped lang="scss">
.dialog-content {
	width: 90vw;
	max-width: 1100px;
	height: 90vh;
	background: var(--white);
}
.rounded {
	border-radius: 8px !important;
}

.save-button {
	width: 155px !important;
	height: 38px !important;
	font-size: 13px !important;
	color: #ffffff !important;
	border-radius: 6px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: #6761ef !important;
	&.disabled {
		border-color: transparent !important;
	}
}
.flows-container {
	height: 100%;
	max-height: calc(100% - 70px);
}
.router-link {
	&.selected {
		::v-deep {
			.module-card {
				transition: 0.2s;
				background-color: #e8f0fe;
			}
		}
	}
	&.disabled {
		pointer-events: none;
		::v-deep {
			.module-card {
				opacity: 0.3;
				pointer-events: none;
			}
		}
	}
}
</style>
